//import RightScrollFix from "@/pcomponents/common/content/list/right_scroll_fix";
import { useEffect } from 'react';

function RightScrollFix(props: any) {
  let myProps = {
    right_ref: null,
    limit_scroll_top: 150,
    start_scroll_top: "0px",
    height:"100vh",
    ...props
  };
  let right_ref = myProps.right_ref;

  useEffect(() => {
    addEventListener("scroll", (e: any) => {
      if (right_ref.current) {
        if (window.scrollY > myProps.limit_scroll_top) {
          right_ref.current.style.position = "fixed";
          right_ref.current.style.width = right_ref.current.parentElement.offsetWidth + "px";
          right_ref.current.style.top = myProps.start_scroll_top;
          right_ref.current.style.height=myProps.height;
          right_ref.current.style.overflow="auto";
        } else {
          right_ref.current.style.position = "relative";
          right_ref.current.style.height="";
        }
      }
    });
  }, []);

  return (
    <></>
  );
};
export default RightScrollFix;